module.exports = __webpack_public_path__ + "img/discount.4e1bbdf2.svg";